import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { Form, Container, Checkbox, Segment, Grid, Message, Button, Header } from 'semantic-ui-react'
import TextEditor from '../TextEditor'
import useStoreResumo from './store'
import { PropsFormResumoType, PropsRelatosType, ResumoType } from './types'
import { EllipsisParagraph } from '../EllipsisParagraph'
import { Sigla } from '../Sigla'
import './styles.less'
import dayjs from 'dayjs'
import { useStore } from '../../stores/useStoreProfile'

const RelatosValidados = (props: PropsRelatosType) => {
  const { relatos, value, onChange } = props
  return <Grid columns='equal'>
    <Grid.Row>
      <Grid.Column>
        <Header>ULTIMOS RELATOS</Header>
      </Grid.Column>
    </Grid.Row>
    <Grid.Row>
      <Grid.Column width={2}>
        Área
      </Grid.Column>
      <Grid.Column>
        Descrição
      </Grid.Column>
      <Grid.Column>
        Necessidade de Apoio
      </Grid.Column>
      <Grid.Column width={1}>
        Selecione
      </Grid.Column>
    </Grid.Row>
    {relatos.length
      ? relatos.map(e =>
        <Grid.Row key={e.id}>
          <Grid.Column width={2}>
            <Sigla
              size={8}
              requer_atencao={e.requer_atencao}
            >
              {e.sigla_departamento}
            </Sigla>
          </Grid.Column>
          <Grid.Column>
            <EllipsisParagraph
              htmlTitle={e.sigla_departamento}
              htmlText={e.ultimos_andamentos || ''}
              rows={3}
            />
          </Grid.Column>
          <Grid.Column>
            <EllipsisParagraph
              htmlTitle={e.sigla_departamento}
              htmlText={e.necessidade_apoio || ''}
              rows={3}
            />
          </Grid.Column>
          <Grid.Column width={1}>
            <Form.Field>
              <Checkbox
                name='selecionar-relatorio'
                value={e.sigla_departamento}
                checked={Boolean(e.id && value.includes(e.id))}
                onChange={() => {
                  e.id && onChange(value.includes(e.id)
                    ? value.filter(v => v !== e.id)
                    : [...value, e.id]
                  )
                }}
              />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>
      )
      : <Grid.Row>
        <Grid.Column>
          <Message size='mini' compact icon='inbox' header='Não há dados' />
        </Grid.Column>
      </Grid.Row>
    }
  </Grid>
}

const ShowResumo = ({ resumo, basic }: { resumo: ResumoType, basic?: boolean }) => {
  return <Segment basic={basic} clearing>
    <Grid columns='equal'>
      <Grid.Row>
        <Grid.Column >
          Situacao
        </Grid.Column>
        <Grid.Column>
          Necessidade de apoio
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <EllipsisParagraph
            htmlText={resumo.situacao || ''}
            rows={3}
          />
        </Grid.Column>
        <Grid.Column>
          <EllipsisParagraph
            htmlText={resumo.deliberacao || ''}
            rows={3}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          Situação: {resumo?.dsc_situacao}
        </Grid.Column>
        <Grid.Column>
          Data: {dayjs(resumo.data_resumo).format('L')}
        </Grid.Column>
        <Grid.Column>
          Criado por: {resumo?.criado_por}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  </Segment>
}

export const FromResumo = (props: PropsFormResumoType) => {
  const { item, itemId } = props
  const { store, ultimoResumo, success, relatos, api } = useStoreResumo()
  const [init, setInit] = useState(true)
  const history = useHistory()
  const { store: profile } = useStore()
  const { add_resumo, change_resumo, enviar_resumo, validar_resumo, concluir_revisao_resumo, solicitar_revisao_resumo } = profile.permissions

  const checkDepartamento = (e: any) => Boolean(
    e.find((e: any) => e.departamento === item.departamento?.toString())
  )

  const addResumo = checkDepartamento(add_resumo) && [undefined, 'validado'].includes(ultimoResumo?.alias_situacao)
  const changeResumo = checkDepartamento(change_resumo)
  const enviarResumo = checkDepartamento(enviar_resumo)
  const validarResumo = checkDepartamento(validar_resumo)
  const concluirRevisaoResumo = checkDepartamento(concluir_revisao_resumo)
  const solicitarRevisaoResumo = checkDepartamento(solicitar_revisao_resumo)
  const situacaoTrabalho = [
    { enabled: enviarResumo, situacao: 'em_elaboracao' },
    { enabled: concluirRevisaoResumo, situacao: 'aguardando_revisao' },
    { enabled: validarResumo, situacao: 'aguardando_validacao' }
  ].filter(e => e.enabled).map(e => e.situacao)

  useEffect(() => {
    if (item.id && init) {
      setInit(false)
      api.list(item.id, situacaoTrabalho)
    }
  }, [init])  // eslint-disable-line

  useEffect(() => {
    if (!store.itemtrabalho_id) {
      !store.itemtrabalho_id && api.setStore({ itemtrabalho_id: itemId })
      api.listRelato(itemId, store.id)
    }
  }, [api, itemId, store.id, store.itemtrabalho_id])

  const showForm = (
    (changeResumo && situacaoTrabalho.includes(store.alias_situacao || '')) ||
    addResumo
  )

  enum Actions {
    enviar,
    validar,
    solicitarRevisao,
  }

  const checkCanAction = (action: Actions) => {
    const situacao = store.alias_situacao || ''
    switch (action) {
      case Actions.enviar:
        return ['', 'em_elaboracao', 'aguardando_revisao'].includes(situacao)
      case Actions.validar:
      case Actions.solicitarRevisao:
        return ['aguardando_validacao'].includes(situacao)
      default:
        return false
    }
  }

  return <Container fluid className='form-resumo'>
    {api.checkError('detail') && <Message
      icon='times circle outline'
      error
      header={api.checkError('detail')}
    />}
    {success && <Message
      icon='check circle outline'
      success
      header={success}
    />}
    {showForm &&
      <Form>
        <RelatosValidados
          name='relatovalidado'
          relatos={relatos}
          value={store.reportesandamentos || []}
          onChange={e => { api.setStore({ reportesandamentos: e }) }}
        />
        <Header>{store.id ? 'RESUMO' : 'NOVO RESUMO'}</Header>
        <Form.Group widths='equal'>
          <Form.Field
            control={TextEditor}
            name='txt-situacao'
            label='Situação'
            value={store.situacao}
            onChange={(e: string) => { api.setStore({ situacao: e }) }}
            error={api.checkError('situacao')}
          />
          <Form.Field
            control={TextEditor}
            name='txt-necessidade-apoio'
            label='Necessidade de apoio'
            value={store.deliberacao}
            onChange={(e: string) => { api.setStore({ deliberacao: e }) }}
            error={api.checkError('deliberacao')}
          />
        </Form.Group>
        {store.id &&
          <Grid columns='equal'>
            <Grid.Row>
              <Grid.Column>{store.dsc_situacao}</Grid.Column>
              <Grid.Column>{store.data_resumo}</Grid.Column>
              <Grid.Column>{store.criado_por}</Grid.Column>
            </Grid.Row>
          </Grid>
        }
      </Form>
    }

    {!showForm && ultimoResumo && <ShowResumo resumo={ultimoResumo} />}

    <Segment basic clearing className={'actions-button'}>
      <Button floated='left' name="btn-cancelar" title="Clique aqui para voltar" onClick={() => history.goBack()}>Cancelar/Fechar</Button>
      {validarResumo &&
        <Button
          floated='right'
          name='btn-salva-publica-relato'
          onClick={async () => {
            await api.validar()
            setInit(true)
          }}
          title='Salvar e publicar'
          disabled={!showForm || api.checkLoading('validar') || !checkCanAction(Actions.validar)}
        >Salvar e publicar</Button>
      }
      {solicitarRevisaoResumo &&
        <Button
          floated='right'
          name='btn-devolve-relato'
          onClick={async () => {
            await api.solicitarRevisao()
            setInit(true)
          }}
          title='Devolver relato'
          disabled={!showForm || api.checkLoading('solicitarRevisao') || !checkCanAction(Actions.solicitarRevisao)}
        >Devolver</Button>
      }
      {(enviarResumo || concluirRevisaoResumo) &&
        <Button
          floated='right'
          name='btn-salvarenviar'
          onClick={async () => {
            await api.enviar()
            setInit(true)
          }}
          title='Salvar e enviar'
          disabled={!showForm || api.checkLoading('enviar') || !checkCanAction(Actions.enviar)}
        >Salvar e enviar</Button>
      }
      {changeResumo &&
        <Button
          floated='right'
          onClick={() => api.save()}
          name='btn-salva-relato'
          title='Salvar relato'
          disabled={!showForm || api.checkLoading('save')}
        >Salvar</Button>
      }
    </Segment>
  </Container>
}
